var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 15.6C27.8 15.6 28.8 14.6 28.8 13.2C28.8 11.8 27.8 10.8 26.4 10.8C25 10.8 24 11.8 24 13.2C24 14.6 25 15.6 26.4 15.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4001 22.6L35.6001 12.2V9.40001C35.6001 7.60001 34.2001 6.20001 32.4001 6.20001H10.6001C8.8001 6.20001 7.4001 7.60001 7.4001 9.40001V26.2H4.6001V28.4H7.4001V29.8H4.6001V32H7.4001V33.4H4.6001V35.6H7.4001V39.6C7.4001 41.4 8.8001 42.8 10.6001 42.8H32.6001C34.4001 42.8 35.8001 41.4 35.8001 39.6V22.6H43.6001H43.4001ZM33.8001 39.6C33.8001 40.2 33.2001 40.8 32.6001 40.8H10.6001C10.0001 40.8 9.4001 40.2 9.4001 39.6V35.6H26.4001V33.4H9.4001V32H26.4001V29.8H9.4001V28.4H26.4001V26.2H9.4001V9.40001C9.4001 8.80001 10.0001 8.20001 10.6001 8.20001H32.6001C33.2001 8.20001 33.8001 8.80001 33.8001 9.40001V12.2L26.2001 21.6L20.4001 14.8L14.6001 22.6H33.6001V39.6H33.8001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default __webpack_public_path__ + "static/media/templates.5240c0da198bc2f6cbdda4065d5c1e8c.svg";
export { ForwardRef as ReactComponent };